// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2xAo2","approved":"Status_approved__3xRPx","rejected":"Status_rejected__RhF8z","expired":"Status_expired__21uQo","label":"Status_label__3M6hL"};